import { combineReducers } from 'redux';

import agents from './agents';
import user from './user';
import modals from './modals';
import auth from './auth';
import guide from '../guide/reducer';
import details from './userDetails';
import permissions from './userPermissions';
import access from './userAccess';
import batch from './batch';
import batchUI from './batchUI';
import adduser from './adduser';
import profile from './profile';
import carriers from './carriers';
import translations from './translations';
import addagency from './addagency';
import agencies from './agencies';
import addcampaign from './addcampaign';
import campaign from './campaign';
import theme from './theme';
import records from './records';
import sites from './sites';
import leadStatus from './lead_status';
import logos from './logos';
import diff from './transcript-diff';
import session from './session';
import rts from './rts';
import config from './config';
import reports from './reports';
import threeWay from './three_way';
import leads from './leads';

// profile and user-admin's view of user-details
import shoppers from './shoppers';
import enrollments from './enrollments';
import soas from './soas';
import appointments from './appointments';

export default () => combineReducers({
  access,
  addagency,
  addcampaign,
  adduser,
  agencies,
  agents,
  appointments,
  auth,
  batch,
  batchUI,
  campaign,
  carriers,
  config,
  details,
  diff,
  enrollments,
  guide,
  leads,
  leadStatus,
  logos,
  modals,
  permissions,
  profile,
  records,
  reports,
  rts,
  session,
  shoppers,
  sites,
  soas,
  theme,
  threeWay,
  translations,
  user,
});
